export default __webpack_public_path__ + "media/images/banner/banner-34-69a26921c3aaf9d2fc6bc9ad64904f04.jpg";